import { Modal } from "antd";
import { useSelector } from "react-redux";
import { OutliersTable } from "./OutliersTable";

export const OutlierDialog = ({
  open,
  onCancel,
  outliers,
  setUpdatedOutliers
}) => {

  const modalTitle = 'Skip Outliers / Mark Outliers as Valid';

  return (
    <Modal
      open={open}
      title={modalTitle}
      onCancel={onCancel}
      footer={null}
      width={850}
      style={{ top: 120 }}
    >
      <div className="outlier-table-container">
        <OutliersTable 
          outliers={outliers}
          setUpdatedOutliers={setUpdatedOutliers}
          onCancel={onCancel}
        />
      </div>
    </Modal>
  );
};
